import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tileinput',
  templateUrl: './tileinput.component.html',
  styleUrls: ['./tileinput.component.scss']
})
export class TileinputComponent implements OnInit {

  @Input() model!: string[];
  @Input() name!: string;
  @Input() placeholder!: string;
  @Output() modelChange = new EventEmitter<string[]>();

  constructor() { }

  ngOnInit(): void {
  }

  eventChange(item: any): void{
    this.modelChange.emit(this.model);
  }

}
